import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Tippy from '@tippyjs/react';
import { CSVLink } from "react-csv";
import { ShopperContext } from '../context/shopper'
import HeadingBuilder from '../components/HeadingBuilder';
import AddFunctionRestricted from '../components/AddFunctionRestricted';
import ShowAlert from '../components/ShowAlert';
import Checkbox from '../components/Checkbox';
import { useStyles } from "../hooks/useStyles";
import { useUtils } from "../hooks/useUtils";
import { useLookups, usePhrasing } from "../hooks/useSkuUtils";
import SkuLink from '../components/SkuLink'
import CircleLink from '../components/CircleLink'
import GetIcon from '../components/GetIcon'
import { getTimestringNow } from '../utils'; 
import * as Constants from '../constants';
import { Link } from 'react-router-dom'
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";

const Skus = () => {
  const { shopper, circles, circleShoppers, skus, signedIn,
          unsetFoundSkus,
        } = useContext(ShopperContext);

  const { scircle_id } = useParams();
  console.log( 'sci c', scircle_id);

  const { s_by_identifier, any_identifiers_in_multiple_postal_codes,
          getCountryCodeIfGT1, checkForParamAndNoParamState,
          is_shopper_a_circle_admin, is_shopper_admin_of_some_circle } = useUtils();

  if (checkForParamAndNoParamState({stateRes: circles, param_id: scircle_id}) ) {
    // If there is a scircle_id but no circles, go back to the 'circles' page.
    window.location.replace('/circles/');
  }

  const onlyOneCircleId =
    (Array.isArray(circles) && circles.length === 1)  ? circles[0].id : null;
  // console.log('first circle id is |', onlyOneCircleId, '|')

  // If shopper belongs to only one circle,
  // or was directed here by clicking a circle's 'Circle's Skus' button,
  // the Skus page should focus on skus of that circle.
  const onlyWorkWithThisCircleId =  onlyOneCircleId || scircle_id || null;
  // console.log('scio onlyWorkWithThisCircleId', onlyWorkWithThisCircleId);
  const scircleIdObj = 
    onlyWorkWithThisCircleId ? circles.find(c => c.id == onlyWorkWithThisCircleId) : null;
  // console.log('scio scircleIdObj', scircleIdObj);

  const { t } = useTranslation();

  const { tableShow, textAlignLeft, tableShowNarrow } = useStyles();
  const { getIdColTippyText, noDotZero } = usePhrasing();
  const [showIdentifier, setShowIdentifier] = useState(false);
  const [showStore, setShowStore] = useState(false);
  const [showSkuDespiteHidden, setShowSkuDespiteHidden] = useState(false)
  const [showCircleZipCodes, setShowCircleZipCodes] = useState(true);

  const countryCode =
    scircleIdObj
      ? getCountryCodeIfGT1({
          shopper, countryCode: scircleIdObj.country
        })
      : null;

  const circlePostalCodeAndMaybeCountry =
    scircleIdObj
      ? countryCode
        ? scircleIdObj.postal_code + ' / ' + countryCode
        : scircleIdObj.postal_code
      : null;

  // While initializing Skus.js, update showCircleZipCodes appropriately based
  // on whether shopper is in two circles that have the same identifier.
  // We can't just seed 'useState' with the 'any_identifiers' value since
  // the early/instant value for 'circles' looks undefined. Seems better luck
  // to use 'useEffect' (with its late lookup?)
  // TODO: Irritatingly, this fails if do refresh of Skus.js though it works
  // ok if arrive here by clicking 'Skus'. Why doesn't 'circles' have a
  // value in place upon refresh for 'any_identifiers' to work with?
  //console.log('setmyst Skus circles', circles);
  useEffect(() => {
    setShowCircleZipCodes(
      any_identifiers_in_multiple_postal_codes({circles}) ? true : false
    );
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  // The warning wants to load dep array with [circles,
  // any_identifiers_in_multiple_postal_codes] but that causes useEffect to fire
  // every time we click the 'toggleShowCircleZipCodes' button. Not good
  // since this hardcodes a setting of Show or Hide for the button based
  // strictly on presence of duplicate identifiers. The shopper may still
  // want to toggle the value for personal reasons.

  const { lookup_category, lookup_tax_type } = useLookups();

  const [showRemoveSkuColumn, setShowRemoveSkuColumn] = useState(false);
  const toggleShowRemoveSkuColumn = () => {
      setShowRemoveSkuColumn(prev => !prev);
      console.log("srsc", showRemoveSkuColumn);
  };

  const handleSearchLinkClick = () => {
    unsetFoundSkus();
  };

  const skuHeadlineTippyText =
    t('sku.formPart.headlineTippyContent') + (
      (Array.isArray(circles) && circles.length === 0)
        ? t('sku.formPart.headlineTippyContentIfNoCircle')
        : ''
    );

  const removeSkuButtonTippyText =
    t('sku.toggleButtonToRemoveSku.tippyContentA') +
    t('global.clickCheckboxToShowHideColumnTippyText') +
    t('sku.toggleButtonToRemoveSku.tippyContentC') +
    t('global.qWantToProceedTippyText');

  const circleColumnComment =
    t('circle.postal_code.purposeTippyContent', {
      objectType: t('global.label.sku'),
      countryNote:
        shopper.country_count > 1  ?  t('circle.postal_code.countryNote') : ''
    });

  const hiddenSkusCheckboxTippyAlertText =
    t('sku.hideAndRevealHiddenSkus.tippyCheckboxAlert', {
      tippyShowHideCheckbox: t('global.clickCheckboxToShowHideColumnTippyText')
    })

  const hiddenSkusCheckboxTippyInfoText =
    t('sku.hideAndRevealHiddenSkus.tippyCheckboxInfo', {
      labelShowColumn: t('sku.hideAndRevealHiddenSkus.labelShowColumn')
    })

  const [showDownloadSkusAlert, setShowDownloadSkusAlert] = useState(false);
  const toggleDownloadSkusAlert = () =>  setShowDownloadSkusAlert(! showDownloadSkusAlert);


  if (signedIn) {
      console.log('CircskusA', skus);

      function s_by_circle_zip_store_sku( a, b )
      {
        //console.log("sbitd", a)
        if ( a.circle.identifier.toLowerCase() < b.circle.identifier.toLowerCase()){
          return -1;
        }
        if ( a.circle.identifier.toLowerCase() > b.circle.identifier.toLowerCase()){
          return 1;
        }
        if ( a.circle.postal_code.toLowerCase() < b.circle.postal_code.toLowerCase()){
          return -1;
        }
        if ( a.circle.postal_code.toLowerCase() > b.circle.postal_code.toLowerCase()){
          return 1;
        }
        if ( a.store_label < b.store_label ){
            return -1;
        }
        if ( a.store_label > b.store_label ){
          return 1;
        }
        if ( a.label < b.label ){
            return -1;
        }
        if ( a.label > b.label ){
          return 1;
        }
        return 0;
      }
    
      function skus_exist(array) {
        if (array.length > 0) {
          return true
        }
        return false
      }

      const headers = [
        { label: t('sku.id.csvLabel'),             key: "id" },         // "Sku ID",
        { label: t('circle.id.csvLabel'),          key: "circle_id" },  // "Circle ID" "circle_id"
        { label: t('circle.identifier.csvLabel'),  key: "circle_identifier" }, // "Circle Name" "circle_name"
        { label: t('circle.postal_code.csvLabel'), key: "circle_postal_code" }, // "PCode" "pcode"
        { label: t('sku.identifier.label'),        key: "identifier" }, // "Lookup ID" "identifier"
        { label: t('sku.label.label'),             key: "label" },      // "Name/Label" "label"
        { label: t('sku.detail.label'),            key: "detail" },     // "Details" "detail"
        { label: t('sku.brand.label'),             key: "brand" },      // "Brand" "brand"
        { label: t('sku.category.label'),          key: "category" },   // "Category" "category"
        { label: t('sku.store_label.label'),       key: "store_label" },// "Store" "store_label"
        { label: t('sku.type.label'),              key: "type" },       // "Type" "type"
        { label: t('sku.typical_weight.label'),    key: "typical_weight" }, // "Typical Weight" "typical_weight"
        { label: t('sku.quantity.csvLabel'),       key: "quantity" },   // "Quantity" "quantity"
        { label: t('sku.units.csvLabel'),          key: "units" },      // "Units" "units"
        { label: t('sku.unit_count.csvLabel'),     key: "unit_count" }, // "Unit Count" "unit_count"
        { label: t('sku.tax_type.label'),          key: "tax_type" }    // "Tax Status" "tax_type"
      ];

      const skusList =
        skus_exist(skus)
        ?
          skus
            .filter(
              // If the 'scircle_id' param says to only show skus from a given
              // circle, then filter skus against that.
              // If the shopper is a member of only one circle, then, by
              // definition, no skus belonging to another circle can appear, so
              // let all skus through and they will belong to the same circle!
              sku => scircle_id  ?  sku.circle.id == scircle_id  :  true
            )
            .filter(
              // If a sku is not hidden, show it! Else, it's hidden, so
              // only show it if the shopper is an admin of sku's circle.
              // 'showSkuDespiteHidden' lets admins control whether to
              // even view 'Hidden' skus.
              sku => !sku.is_hidden  ||  (showSkuDespiteHidden &&
                is_shopper_a_circle_admin({
                  cShoppers: circleShoppers, circle_id: sku.circle_id, shopper_id: shopper.id
                })
              )
            )
            .sort( s_by_circle_zip_store_sku )
        : null;

      const thereAreSkus =   skusList &&  skusList.length > 0;
      console.log('tl is t/f', thereAreSkus ? 'there are skus' : 'no skus');

      const skusListForCsv =
        thereAreSkus
          ? skusList
            .map(s => {
              return {
                circle_id: s.circle_id.toString(),
                circle_identifier: s.circle.identifier,
                circle_postal_code: s.circle.postal_code,
                id: s.id.toString(),
                identifier: s.identifier,
                label: s.label,
            detail: s.detail && s.detail.replace(/"/g, t('global.abbrev.inch')),
                brand: s.brand,
                category: s.category && lookup_category({category: s.category}),
                store_label: s.store_label,
                type: s.type,
                typical_weight: s.typical_weight && s.typical_weight.toString(),
                quantity: s.quantity && s.quantity.toString(),
                units: s.units,
                unit_count: s.unit_count &&
                                      noDotZero({num: s.unit_count}).toString(),
                tax_type: s.tax_type && lookup_tax_type({tax_type: s.tax_type})
              }
            })
          : null;
      console.log('Skus.js skusListForCsv: ', skusListForCsv);

      const textForSkusToCsvLink =
        onlyWorkWithThisCircleId
          ? t('sku.button_text.labelSkusOfCircle')
            // Download Circle's Skus to CSV File
          : t('sku.button_text.label')
            // Download Skus to CSV File

      const tippyForSkusToCsvLink =
        onlyWorkWithThisCircleId
          ? t('sku.button_text.downloadReportOfCircle')
            // Download a listing of the Circle's Skus to a spreadsheet (CSV file.)
          : t('sku.button_text.downloadReport')
            // Download a listing of all of the Skus of your Circles to a spreadsheet (CSV file.)

      const skusListOfSkuLinks =
        thereAreSkus
          ? skusList
            .map(sku => {
            console.log('s_before', sku);
            const s = {...sku};
            console.log('s_after', s);

            return <SkuLink key={s.id}
              sku = { s }
              onlyOneCircleId = {onlyWorkWithThisCircleId}
              if_shopper_is_circle_admin = {
                is_shopper_a_circle_admin({
                  cShoppers: circleShoppers, circle_id: sku.circle_id, shopper_id: shopper.id
                })
              }
              showCircleZipCodes  = {showCircleZipCodes}
              showIdentifier      = {showIdentifier}
              showStore           = {showStore}
              showRemoveSkuColumn = {showRemoveSkuColumn}
            />
            })
          : null;

      const mkListOfCircleAddSkuLinks = ({
            circs = circles,
            scirc_id = scircle_id,
        }) => {
            console.log('Circs', circs);
            const links_to_circles_for_skus =
              circs
                .filter(
                  // Same filter logic as above for branching on 'scircle_id'.
                  // If shopper only has one circle, then filtering others silly
                  circle => scirc_id  ?  circle.id == scirc_id  :  true
                )
                .sort(s_by_identifier)
                .map( (circle) => 
                 <tr key={circle.id}>
                  <td>
                    <CircleLink circle = {circle} />
                  </td>
                  <td>
                    <HeadingBuilder
                      Size = "h6"
                      containerType  = "container-left"
                      headingText    = {
                        circle.xip_code + getCountryCodeIfGT1({
                          shopper, countryCode: circle.country, inString: true
                        })
                      }
                      // the Circle's postal_code and maybe its country
                    />
                  </td>
                  <td>
                    <center>
                    { circle.is_current
                      ? <Link to={`/circles/${circle.id}/skus`}>
                          <GetIcon toGet={Constants.GET_ICON_PLUS} />
                        </Link>
                      : <>{Constants.DASH}</>
                    }
                    </center>
                  </td>
                  <td>
                    <center>
                    { circle.is_current
                      ? <Link to={`/circles/${circle.id}/search_skus`}
                              onClick={handleSearchLinkClick}>
                          <GetIcon toGet={Constants.GET_ICON_SEARCH} />
                        </Link>
                      : <HeadingBuilder
                          headingText   = {Constants.DASH}
                          // a 'dash' character
                          tippyText     = {Constants.DOT}
                          tippyInfoText =
                            {t('circle.circleNotCurrent.tippyContent')}
                          // There is an issue with the Circle's payment status
                        />
                    }
                    </center>
                  </td>
                 </tr>
                );
            return links_to_circles_for_skus;
      }

      const listOfCircleAddSkuLinks = mkListOfCircleAddSkuLinks({});
      console.log('listOfCircleAddSkuLinks', listOfCircleAddSkuLinks);
      // Ack! A valid array that is empty returns true.
      // Guard against empty array with boolean length check.
      const thereAreCircleAddSkuLinks =  listOfCircleAddSkuLinks.length > 0;

      const createOrSearchForSkuButton = ({
                              skusList, focusOnThisCircleId, scircIdObj }) => {
        // 'focusOnThisCircleId' likely has value of: onlyWorkWithThisCircleId
        const returnVal = [];
        // At one point, an error message complained about lack of a key.
        // Not getting that error now.
        // Likely because when JSX encounters directive to print result of
        // this function, and the result is a list (an array), it gets worried
        // if the array elements do not have keys. Adding "key='10'" would
        // have given the single element in the list the necessary 'key' prop
        // and so quiesced the warning.

        if (focusOnThisCircleId) {
          // If the skus page will only show skus for one circle, then the
          // control for adding new skus already knows which circle the sku
          // will be for! So, do 'add' or 'search' for that circle.
          // Don't dish off to a list of circles to choose from for
          // 'create/search for a sku'.

          // Don't show buttons to add Sku to Circle's Maybe-List if not paid up
         if (scircIdObj.is_current) {
          returnVal.push(
           <React.Fragment key='10'>
            <HeadingBuilder
              Size           = 'h5'
              headingText    = {t('sku.circleAddSku.label')}
              // Add a new Sku to Circle's Maybe-List
              linkUrl        = {`/circles/${focusOnThisCircleId}/skus`}
              goButtonText   = {Constants.GET_ICON_PLUS}
              linkUrl2       = {`/circles/${focusOnThisCircleId}/search_skus`}
              goButton2Text  = {Constants.GET_ICON_SEARCH}
              tippyAlertText = {t('sku.circleAddSku.directTippyContent')}
              tippyText      = {t('sku.circleAddSku.directTippyContent')}
              // Click the 'plus' button to add a new Sku to the Maybe-List.
            />
           </React.Fragment>
          )
         }

          return returnVal;
        }

        // If the shopper has skus, they must be in more than one circle, so
        // must choose which circle. (Otherwise the focusOnThisCircleId block
        // would have run and already done a 'return'.)
        // If a bunch of skus are filling the page, button here at the top
        // should redirect to the 'href' below to pick a circle.
        if (skusList &&  skusList.length > Constants.SMALL_NUM_OF_SKUS) {
          returnVal.push(
            <React.Fragment key='20'>
              <HeadingBuilder
                Size           = 'h5'
                hrefTo         = '#CreateASkuForACircle'
                headingText    = {t('sku.circleAddSku.labelPlural')}
                // Add a new Sku to a Circle's Maybe-List
                goButtonText   = {Constants.GET_ICON_RT_ARROW}
                tippyAlertText = {t('sku.circleAddSku.hrefChooseCircleTippyContent')}
                tippyText      = {t('sku.circleAddSku.hrefChooseCircleTippyContent')}
                // Click this button for the panel to choose a Circle and access ...
              />
              <br/>
            </React.Fragment>
          )
          return returnVal;
        }

        // Else don't return a button.
        return null;
      }
    

      const toggleShowCircleZipCodes = () => {
        setShowCircleZipCodes( () => !showCircleZipCodes );
      };

    const handleIdClick = event => {
      setShowIdentifier(current => !current);
    };

    const handleStoreClick = event => {
      setShowStore(current => !current);
    };

      const toggleShowingHiddenSkus = () => {
        setShowSkuDespiteHidden( () => !showSkuDespiteHidden );
      };

      // Skus marked 'Hidden' only show if you are admin of the sku's Circle.
      // But admins might also like the silent treatment, i.e. might prefer
      // hiding 'Hidden' skus even though they are the admin. So, let's offer
      // a toggle for admins for showing 'Hidden's.
      // It would be obnoxious for non-admins to see a toggle which has no
      // effect, since they don't see 'Hidden' skus in the first place.
      // But, 'admin' is a circle-specific setting, and on this page, a
      // shopper might be seeing skus for multiple circles, some of which
      // they might not be an admin for.
      // It turns out that screening out 'Hidden' records for non-admin
      // circles doesn't matter since the non-admin shopper (who is admin
      // for a different circle) won't be seeing those anyway!
      // Thus, if we show the toggle to anyone who is admin of any circle,
      // then the broadly-granted power to show/hide will still only matter
      // for skus in circles they administer.
      return (
          <>
            <article>
              <HeadingBuilder
                Size = "h3"
                headingText    = {t('sku.formPart.headlineLabel')}
                // Items / Skus / Maybe-List
                tippyAlertText = {skuHeadlineTippyText}
                tippyText      = {Constants.DOT}
              />

              { onlyWorkWithThisCircleId
                ? <HeadingBuilder
                    Size = "h5"
                    headingText    = {t('global.label.forCircle')}
                    value          = {scircleIdObj.identifier}
                    // for Circle uioup
                    linkUrl        = {`/circles/${onlyWorkWithThisCircleId}`}
                    tippyAlertText = {t('sku.formPart.forCircleTippyContent')}
                    tippyText      = {Constants.DOT}
                    tippyInfoText  = {circlePostalCodeAndMaybeCountry}
                  />
                : null
              }

              { shopper.show_tippy_help_alert_icons
                ? <HeadingBuilder
                    Size = "h6"
                    headingText    = {t('sku.formPart.subHeadlineLabel')}
                    // This is your Menu of things you might get.
                    tippyAlertText = {t('sku.formPart.subHeadlineTippyContent')}
                    tippyText      = {Constants.DOT}
                  />
                : null
              }

              {createOrSearchForSkuButton({
                skusList,
                scircIdObj: scircleIdObj,
                focusOnThisCircleId: onlyWorkWithThisCircleId
              })}
      
              { thereAreSkus &&
                (
            // If shopper is in only one circle or is here for a single circle,
            // and is an admin of the circle
                  ( onlyWorkWithThisCircleId &&  is_shopper_a_circle_admin({
                      cShoppers: circleShoppers,
                      circle_id: onlyWorkWithThisCircleId,
                      shopper_id: shopper.id
                    })
                  ) || (
        // or viewing skus for all circles, and is an admin for one of them
                !onlyWorkWithThisCircleId &&  is_shopper_admin_of_some_circle({
                      cShoppers: circleShoppers, shopper_id: shopper.id
                    })
                  )
                )
                &&
        // then do:
                <>
                  <Checkbox
                    isChecked    = {showSkuDespiteHidden}
                    setIsChecked = {toggleShowingHiddenSkus}
                    label    = {t('sku.hideAndRevealHiddenSkus.labelShowColumn')}
                    // Show 'Hidden Skus' column?
                    tippyAlert   = {hiddenSkusCheckboxTippyAlertText}
                    tippyInfo    = {hiddenSkusCheckboxTippyInfoText}
                  />
                  <Checkbox
                    isChecked    = {showRemoveSkuColumn}
                    setIsChecked = {toggleShowRemoveSkuColumn}
                    label    = {t('sku.toggleButtonToRemoveSku.labelShowColumn')}
                    // Show 'Remove Sku?' column?
                    tippyAlert   = {removeSkuButtonTippyText}
                  />
                  <br/>
                </>
              }
              { skusListForCsv
    // CSVLink throws error if data=null, so verify skusListForCsv not null
                ? <div className="oneline-container">
                    {textForSkusToCsvLink}
                    {/*
                      Download Circle's Skus to CSV File
                      or
                      Download Skus to CSV File
                    */}
                    &nbsp;
                    <CSVLink
                      data={skusListForCsv}
                      headers={headers}
                      filename={ shopper.shortname
                        + '_skus'
                        + '_' + getTimestringNow().substring(2)
                        + '.csv'}
                        // gfbj_skus_230228172423.csv
                      target='_blank'
                    >
                      <Tippy content={tippyForSkusToCsvLink} >
                        <GetIcon toGet={Constants.GET_ICON_RT_ARROW_2EM_GRAY}/>
                      </Tippy>
                      {/*
                        // can't do HeadingBuilder and
                        // can't list tippyAlertText here because its button,
                        // while of type="button", acts as a trigger for CSVLink
                        // Could check this...
                      */}
                    </CSVLink>
                    <HeadingBuilder
                      // ? for: 'Download Skus to CSV' button
                      tippyAlertText = {tippyForSkusToCsvLink}
                      showTippyAlert = {showDownloadSkusAlert}
                      toggleTippyAlert = {toggleDownloadSkusAlert}
                      tippyInfoText  = {t('ordersList.button_text.infoDebugText')}
                    />
                  </div>
                : null
              }
              <ShowAlert showAlert = {showDownloadSkusAlert}
                          alertMsg = {t('sku.button_text.downloadReport')} />
              <br/>

              { skusListOfSkuLinks
                  ? <Table striped bordered hover size="sm" style={tableShow}>
                      <thead style={textAlignLeft}>
                        <tr>
                          { onlyWorkWithThisCircleId
                            ? null
                            : <>
                          <th>
                            <HeadingBuilder
                              containerType  = 'container-hug-bottom-left'
                              headingText    = {t('global.label.circle')}
                              // Circle
                              buttonAction   = {toggleShowCircleZipCodes}
                              tippyText      = {circleColumnComment}
                              tippyAlertText = {circleColumnComment}
                              // What Circle does this Sku belong to? // You can reveal (or hide) the Xip code...
                            />
                          </th>
                          { showCircleZipCodes
                              ? <th>
                                  { t('global.label.xipCode') }
                                  {/* Xip Code */}
                                </th>
                              : null
                          }
                              </>
                          }
                          <th>
                            <HeadingBuilder
                              containerType  = 'container-hug-bottom-left'
                              headingText    = {t('ordersList.id_col.label')}
                              // ID
                              buttonAction   = {handleIdClick}
                              tippyAlertText = {getIdColTippyText()}
                              tippyText      = {Constants.DOT}
                  // Click 'ID' button to toggle showing identifier values below.
                            />
                          </th>
                          <th>
                            <HeadingBuilder
                              containerType  = 'container-hug-bottom-left'
                              headingText    = {t('sku.store_label.label')}
                              // Store
                              buttonAction   = {handleStoreClick}
                              tippyAlertText = {t('sku.store_label.tippyContentSkus')}
                              tippyText      = {t('sku.store_label.tippyContentSkus')}
                              // Click to show or hide 'Store' values below.
                            />
                          </th>
                          <th>
                            { t('global.label.sku') + ' ' + t('sku.label.label')}
                          </th>
                          {/* Sku Name/Label */}
                          <th>{
                              is_shopper_admin_of_some_circle({
                                cShoppers: circleShoppers, shopper_id: shopper.id
                              }) &&
      showSkuDespiteHidden ? t('sku.hideAndRevealHiddenSkus.columnHeader') : null
                            }
                          </th>
                          <th>
                            { showRemoveSkuColumn
                              ? <HeadingBuilder
                                  headingText = {t('sku.removeSku.label')}
                                  // Remove Sku?
                                  tippyText = {t('sku.removeSku.tippyContent')}
                                />
                              : null
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody style={textAlignLeft}>
                        {skusListOfSkuLinks}
                      </tbody>
                    </Table>
                  : <HeadingBuilder
                      headingText    = {t('sku.noSkusDefined.label')}
                      // No Skus defined
                      tippyText      = {Constants.DOT}
                      tippyInfoText  = {t('sku.noSkusDefined.tippyContent')}
                    />
              }
            </article>
              { (
                  thereAreCircleAddSkuLinks && (
                    // If we are not constrained to only one Circle
                    ! onlyWorkWithThisCircleId
                      ||
                    // Or - we ARE constrained, and there are lots of skus above
                    (skusList &&  skusList.length > Constants.SMALL_NUM_OF_SKUS)
                  )
                )
                  ? <article id='CreateASkuForACircle'>
                      <hr />
                      <HeadingBuilder
                        Size           = "h4"
                        headingText    = {t('sku.circleAddSku.labelPlural')}
                        // Add a new Sku to a Circle's Maybe-List
                        tippyAlertText = {t('sku.circleAddSku.tippyContent')}
                        tippyText      = {t('sku.circleAddSku.tippyContent')}
                      />
                      <Table responsive striped bordered hover size="sm" style={tableShowNarrow}>
                        <thead >
                        <tr style={textAlignLeft}>
          <th>
            {t('circle.identifier.label')}
          </th>
          <th>
            <HeadingBuilder
              Size           = 'fw-bold'
              headingText    = {t('global.label.xipCode')}
              // Xip Code
              tippyAlertText = {t('circle.postal_code.quickTippyContent')}
              tippyText      = {t('circle.postal_code.quickTippyContent')}
              // Xip Code indicates where this Shopping Circle is active...
            />
          </th>
          <th>
            <HeadingBuilder
              Size           = 'fw-bold'
              headingText    = {t('sku.circleAddSku.addSku')}
              // Add Sku
              tippyAlertText = {t('sku.circleAddSku.addSkuTippyContent')}
              tippyText      = {t('sku.circleAddSku.addSkuTippyContent')}
            />
          </th>
          <th>
            <HeadingBuilder
              Size           = 'fw-bold'
              headingText    = {t('sku.circleAddSku.searchSku')}
              // Search Sku
              tippyAlertText = {t('sku.circleAddSku.searchSkuTippyContent')}
              tippyText      = {t('sku.circleAddSku.searchSkuTippyContent')}
            />
          </th>
        </tr>
                        </thead>
                        <tbody style={textAlignLeft} >
                          { listOfCircleAddSkuLinks }
                        </tbody>
                      </Table>
                    </article>
                  : (onlyWorkWithThisCircleId && scircleIdObj.is_current)
                      ? null
                      : <AddFunctionRestricted
                    cantDoWhat = {t('circle.circleNotCurrent.cantAddNewSku')}
                    // Can't add a new Sku:
                          altReason = {
                            (Array.isArray(circles) && circles.length === 0)
                              ? t('circle.formPart.noCircles')
                          // You are not a member of any Shopping Circle (yet!)
                              : null
                          }
                        />
              }
          </>
      )
  } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
  }
}


export default Skus;